import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/ui/Header";
import HeroSection from "./components/HeroSection";
import PopularPackages from "./components/PopularPackages";
import ValuePropositions from "./components/ValuePropositions";
import InteractiveMap from "./components/InteractiveMap";
import LiveUpdates from "./components/LiveUpdates";
import TestimonialSection from "./components/TestimonialSection";
import NepalInfoSection from "./components/NepalInfoSection";
import Footer from "./components/Footer";
import Icon from "../../components/AppIcon";

const Homepage = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Sherpa Trekker — Where Adventure Meets Authenticity | Himalayan Trekking
        </title>
        <meta
          name="description"
          content="Discover transformative Himalayan trekking experiences guided by generations of Sherpa wisdom. Authentic cultural immersion, expert guides, and life-changing adventures in Nepal's most spectacular mountains."
        />
        <meta
          name="keywords"
          content="Himalayan trekking, Sherpa guides, Nepal adventures, Everest Base Camp, cultural immersion, mountain expeditions"
        />
        <meta property="og:title" content="Sherpa Trekker — Where Adventure Meets Authenticity" />
        <meta
          property="og:description"
          content="Experience the Himalayas through authentic Sherpa-guided adventures."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://sherpatrekker.com" />
      </Helmet>

      <div className="min-h-screen bg-white">
        <Header />

        <main>
          <HeroSection />
          <PopularPackages />
          <ValuePropositions />
          <InteractiveMap />
          <LiveUpdates />
          <NepalInfoSection />
          <TestimonialSection />
        </main>

        <Footer />

        {/* Scroll to top */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Scroll to top"
          className={`fixed bottom-24 right-6 w-11 h-11 bg-primary text-white rounded-full shadow-lg hover:bg-primary/90 transition-all duration-300 flex items-center justify-center z-40 ${
            showScrollTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
          }`}
        >
          <Icon name="ChevronUp" size={20} />
        </button>

      </div>
    </>
  );
};

export default Homepage;
